import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=9cffe1a0&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./Spinner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=9cffe1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cffe1a0",
  null
  
)

export default component.exports